<template>
  <div v-if="activeRoom && activeRoom.is_blocked" class="w-100">
    <button class="button button__fill button__fill--orange w-100" v-if="activeRoom.is_blocked" @click="emitUnBlockMember">
      <span>{{ textMessages.UNBLOCK_MEMBER }}</span>
    </button>
  </div>
  <div v-else-if="activeRoom" 
    class="box-footer"
    :class="{ 'box-footer--spaced-for-tooltip': showTooltip }">
    <div class="textmessage-area">
      <TooLongMessageTooltip v-if="showTooltip" :key="tooltipKey" :pulseTooltip="true">
        {{ trans.get('pages:chat.message_too_expensive') }}
      </TooLongMessageTooltip>
      <textarea
        ref="roomTextarea"
        :placeholder="textMessages.TYPE_MESSAGE"
        v-model="message"
        @keydown.esc="resetMessage"
        @keydown.enter.exact.prevent="sendMessage"
        @keydown.alt.enter.exact.prevent="message = message + '\n'"
        @focus="onTextareaFocus"
        @blur="onTextareaBlur"
      ></textarea>
      <div
        @click="sendMessage"
        class="text-button"
        :class="{'send-disabled': inputDisabled}"
      >
        <div class="text-button__inner">
            <p class="card-points__points">
                {{ priceByMessage }}
                <i class="demo-icon icon-n-lova-coins"></i></p>
             {{ trans.get('pages:chat.send_button') }}
        </div>
      </div>
    </div>
    <div class="icon-textarea">
      <emoji-picker
        :emojiOpened="emojiOpened"
        :positionTop="true"
        @addEmoji="addEmoji"
        @openEmoji="emojiOpened = $event"
      ></emoji-picker>

      <slot name="room-buttons"></slot><p class="w-chat__msg-price card-points__points">  {{ priceByMessage }}
            <i class="demo-icon icon-n-lova-coins"></i></p>
    </div>
  </div>
  <div v-else></div>
</template>

<script>
// import SvgIcon from '../../../packages/vue-advanced-chat/src/ChatWindow/SvgIcon';
import EmojiPicker from '../../../packages/vue-advanced-chat/src/ChatWindow/EmojiPicker';
import TooLongMessageTooltip from './TooLongMessageTooltip.vue';

export default {
  name: 'RoomBoxFooter',
  components: { EmojiPicker, TooLongMessageTooltip },
  props: {
    currentUserId: { type: [String, Number], default: null },
    activeRoom: Object | null,
    textMessages: { type: Object, required: true },
    coins: { type: Number, required: true }
  },
  data() {
    return {
      message: null,
      emojiOpened: false,
      tooltipKey: 0,
    };
  },
  computed: {
    inputDisabled() {
      return this.isMessageEmpty();
    },
    priceByMessage() {
      const price = this.globals.settings_payment_chat_message;
      const limit = this.globals.settings_payment_chat_limit;
      const length = (this.message || '').length;

      return Math.max(Math.ceil(length / limit) * price, price);
    },
    showTooltip() {
      return (
        this.priceByMessage > this.coins &&
        this.globals.settings_payment_chat_message <= this.coins &&
        !this.isMessageEmpty()
      );
    },
  },
  watch: {
    message() {
      setTimeout(() => this.resizeTextarea(), 0);
    },
    showTooltip() {
      this.$nextTick(() => this.scrollToBottom());
    },
  },
  methods: {
    onTextareaFocus() {
      this.$store.commit('chat/setMessageInputFocused', true);
    },
    onTextareaBlur() {
      this.$store.commit('chat/setMessageInputFocused', false);
    },
    isMessageEmpty() {
      return this.message === null || !this.message.trim();
    },
    resetMessage() {
      this.message = null;
      this.emojiOpened = false;
    },
    focusTextarea() {
      this.$refs['roomTextarea'].focus();
    },
    sendMessage() {
      if (this.isMessageEmpty()) {
        return;
      }

      if (this.showTooltip) {
        this.tooltipKey++; // Re-render the tooltip to restart the pulse animation
        return;
      }

      this.$emit('sendMessage', {
        content: this.message.trim(),
        roomId: this.activeRoom.roomId,
        profileId: this.activeRoom.profile_id,
      });
      this.resetMessage();
    },
    addEmoji(emoji) {
      this.message = (this.message || '') + emoji.icon;
      this.focusTextarea();
    },
    emitUnBlockMember() {
      this.$emit('unBlockMember', {
        roomId: this.activeRoom.roomId,
        profileId: this.activeRoom.profile_id,
      });
    },
    resizeTextarea() {
      const el = this.$refs['roomTextarea'];
      if (!el) {
        return;
      }

      const previousHeight = el.offsetHeight;

      if (el.value.split('\n').length > 8) {
        el.style.overflow = 'visible';
      } else {
        el.style.overflow = 'hidden';
        el.style.height = 0;
        el.style.height = el.scrollHeight + 'px';
      }

      const newHeight = el.offsetHeight;
      const heightDiff = newHeight - previousHeight;
      if (heightDiff > 0) {
        this.scrollToBottom(heightDiff);
      }
    },
    scrollToBottom(offset = null) {
      const scrollContainer = document.querySelector('.container-scroll');
      if (!scrollContainer) {
        return;
      }

      if (offset !== null) {
        scrollContainer.scrollBy({
          top: offset,
          behavior: 'smooth'
        });
      } else if (this.showTooltip) {
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: 'smooth'
        });
      }
    },
  },
  mounted() {
    this.resizeTextarea();
  }
};
</script>


